import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { HookGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { singularize, toPascalCase } from '@cli-utils/text.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths/resolve-schema-action-import-path.js'
import { renderSingleHookComponentTemplate } from '@next-adapter/templates/renderers/generators/hook/generate-single-hook.js'

export function generateSingleHook(
  schema: Schema,
  hooksDir: string,
  options: GeneratorOptions = {}
): HookGeneratorResult {
  const hookFileName = `use-${schema.name}.ts`
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)

  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)

  const content = renderSingleHookComponentTemplate({
    singular: Singular,
    actionImportPath: actionImportPath,
    schemaName: schema.name
  })

  return {
    files: [createGeneratedFile(`${hooksDir}/${hookFileName}`, content)],
    hookName: `use${Singular}`
  }
}
